export const delayBy = (ms) => async (x) =>
  await new Promise((resolve) => setTimeout(() => resolve(x), ms))
